var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0918 87.5489C86.0918 88.4569 85.3541 89.2084 84.4464 89.2084H9.77463C8.86657 89.2084 8.12891 88.4569 8.12891 87.5489C8.12891 86.6408 8.86657 85.8893 9.77463 85.8893H84.4464C85.3541 85.8893 86.0918 86.6408 86.0918 87.5489Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54531 93.9937C13.0065 93.9937 15.8124 91.1878 15.8124 87.7266C15.8124 84.2654 13.0065 81.4595 9.54531 81.4595C6.08408 81.4595 3.2782 84.2654 3.2782 87.7266C3.2782 91.1878 6.08408 93.9937 9.54531 93.9937Z",
    fill: "#304056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2302 93.9937C51.6915 93.9937 54.4973 91.1878 54.4973 87.7266C54.4973 84.2654 51.6915 81.4595 48.2302 81.4595C44.769 81.4595 41.9631 84.2654 41.9631 87.7266C41.9631 91.1878 44.769 93.9937 48.2302 93.9937Z",
    fill: "#304056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9152 93.9937C90.3764 93.9937 93.1823 91.1878 93.1823 87.7266C93.1823 84.2654 90.3764 81.4595 86.9152 81.4595C83.4539 81.4595 80.6481 84.2654 80.6481 87.7266C80.6481 91.1878 83.4539 93.9937 86.9152 93.9937Z",
    fill: "#304056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6119 33.5859C78.6119 47.1278 58.823 75.6962 51.1868 86.216C49.7252 88.2296 46.7354 88.2296 45.2738 86.216C37.6376 75.6962 17.8486 47.1278 17.8486 33.5859C17.8486 16.8066 31.451 3.20422 48.2303 3.20422C65.0096 3.20422 78.6119 16.8066 78.6119 33.5859Z",
    fill: "#488FF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2303 55.8733C60.5389 55.8733 70.5169 45.8952 70.5169 33.5866C70.5169 21.278 60.5389 11.2999 48.2303 11.2999C35.9217 11.2999 25.9436 21.278 25.9436 33.5866C25.9436 45.8952 35.9217 55.8733 48.2303 55.8733Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.406 24.7398V42.429C61.406 44.2731 59.9168 45.7623 58.0869 45.7623H38.3832C36.5393 45.7623 35.0498 44.2731 35.0498 42.429V24.7398C35.0498 22.8953 36.5393 21.4061 38.3832 21.4061H58.0869C59.9168 21.4061 61.406 22.8953 61.406 24.7398Z",
    fill: "#DBDBDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4176 21.4062V29.2552C52.4176 29.673 51.9352 29.9125 51.6015 29.66L48.431 27.2666C48.2496 27.1306 48.0002 27.1306 47.8188 27.2666L44.6483 29.66C44.3146 29.9125 43.8353 29.673 43.8353 29.2552V21.4062H52.4176Z",
    fill: "#304056"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5432 38.7832H39.4062C39.0141 38.7832 38.6969 38.4656 38.6969 38.0739C38.6969 37.6822 39.0141 37.3646 39.4062 37.3646H46.5432C46.9352 37.3646 47.2525 37.6822 47.2525 38.0739C47.2525 38.4656 46.9352 38.7832 46.5432 38.7832Z",
    fill: "#304056"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9747 42.3295H39.4062C39.0141 42.3295 38.6969 42.0119 38.6969 41.6202C38.6969 41.2285 39.0141 40.9109 39.4062 40.9109H42.9747C43.3667 40.9109 43.684 41.2285 43.684 41.6202C43.684 42.0119 43.3667 42.3295 42.9747 42.3295Z",
    fill: "#304056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.09955aba9a76507cfa4f9ae3163cf1b5.svg";
export { ForwardRef as ReactComponent };